import { useQuery } from "@tanstack/react-query";
import { queryClient } from "shared/api/queryClient";
import { getProductsByStudioId } from "../api/getProductsByStudioId";

const QUERY_KEY = "studio-products";

export const useProductsByStudioIdQuery = (studioId?: number) => {
  return useQuery({
    queryKey: [QUERY_KEY, studioId],
    queryFn: async () => {
      if (!studioId) {
        return [];
      }

      return await getProductsByStudioId(studioId.toString());
    },
    enabled: !!studioId,
  });
};

export const invalidateProductsByStudioIdQuery = (studioId: number) => {
  return queryClient.invalidateQueries({ queryKey: [QUERY_KEY, studioId] });
};
